var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58985 0.265784C7.47452 0.169429 7.34131 0.0967695 7.19786 0.0519654C7.05441 0.00716133 6.90353 -0.00890717 6.75386 0.00467998C6.60419 0.0182671 6.45867 0.0612429 6.32563 0.131147C6.19259 0.201051 6.07464 0.29651 5.97855 0.412059L0.264694 7.26868C0.0936598 7.47403 0 7.73282 0 8.00006C0 8.2673 0.0936598 8.52609 0.264694 8.73143L5.97855 15.5881C6.07459 15.7035 6.19243 15.7988 6.32533 15.8687C6.45822 15.9385 6.60358 15.9816 6.7531 15.9952C6.90262 16.0089 7.05337 15.993 7.19674 15.9485C7.34011 15.9039 7.47331 15.8315 7.58871 15.7355C7.70412 15.6394 7.79947 15.5216 7.86934 15.3887C7.9392 15.2558 7.98221 15.1104 7.9959 14.9609C8.00958 14.8114 7.99369 14.6607 7.94912 14.5173C7.90455 14.3739 7.83217 14.2407 7.73613 14.1253L2.62909 8.00006L7.73384 1.87481C7.928 1.64229 8.02189 1.3422 7.99489 1.04049C7.96789 0.73878 7.82221 0.460131 7.58985 0.265784Z",
    fill: "#F7F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.660b105eed7c40c10e76dba7214ae327.svg";
export { ForwardRef as ReactComponent };